import React, {FC, ReactNode} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {KTIcon} from '@/_metronic/helpers'

type BtnProps = {
  label: string,
  className?:string
  icon?: string
  onClick: () => void
}

type Props = {
  title: ReactNode
  description?:string
  collapsable?: boolean
  collapse?: boolean
  id?: string
  children: ReactNode
  className?: string
  link?: {
    to: string
    label: string
    className: string
  }
  buttons?: BtnProps[]
}

const Card: FC<Props> = ({title, description, collapsable, collapse, id, className, link, buttons, children}) => {
  if (collapsable === true && id === undefined) {
    throw new Error('Props "id" is required for collapsable card')
  }

  return (
    <div className={clsx('card', {
      'mb-5 mb-xl-10': className === undefined,
       ...(className ? { [className]: true } : {})
    })}>
      <div
        className={clsx('card-header', {
          'cursor-pointer': collapsable === true,
          'red': collapsable === true
        })}
        data-bs-toggle={collapsable ? 'collapse' : undefined}
        data-bs-target={collapsable ? `#${id}` : undefined}
        aria-expanded={collapsable}
        aria-controls={collapsable ? `${id}` : undefined}
      >
        <div className='card-title align-items-start flex-column'>
          <span className="card-label fw-bold fs-3 mb-1">{title}</span>
          {description && (
            <span className="text-muted fw-semibold fs-7">{description}</span>
          )}
        </div>
        {link && (
          <Link to={link.to} className={link.className}>
            {link.label}
          </Link>
        )}
        {buttons !== undefined && (
          <div className='card-toolbar'>
            {buttons.map((btn: BtnProps, index: number) => (
              <button
                key={`card-btn-${index}`}
                className={btn.className ?? 'btn'}
                onClick={btn.onClick}
                type="button"
              >
                {btn.icon && (
                  <KTIcon iconName={btn.icon} className='fs-2' />
                )}
                {btn.label}
              </button>
            ))}
          </div>
        )}
      </div>

      <div id={id} className={clsx('collapse', {'show': !collapse })}>
        <div className='card-body p-9'>
          {children}
        </div>
      </div>
    </div>
  )
}

export {Card}
